import React from 'react';
import classnames from 'classnames';
import repeatIcon from 'v2/icons/repeat.svg';
import repeatExpiresIcon from 'v2/icons/repeat-expires.svg';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import styles from './extendedRequestTooltip.module.scss';
import { SearchEntity } from 'v2/models';

export const EXTENDED_TOOLTIP_MESSAGE = `This is an Extended Request and will continue to find relevant
                          Providers as they enter the marketplace until this request is archived.`;

interface ExtendedTooltipProps
  extends Pick<SearchEntity, 'extended' | 'expires_at'> {
  showText?: boolean;
  isFreeSearch?: boolean;
}

const ExtendedTooltip = ({
  extended,
  expires_at,
  showText = false,
  isFreeSearch = false,
}: ExtendedTooltipProps) => {
  if (!extended || isFreeSearch) {
    return null;
  }

  const displayIcon = expires_at ? repeatExpiresIcon : repeatIcon;

  return (
    <div className={classnames({ [styles.extendedText]: showText })}>
      <OverlayTrigger
        placement={'top'}
        overlay={
          <Popover id="extended_popover" className={styles.popover}>
            <Popover.Content className={styles.popoverBody}>
              {EXTENDED_TOOLTIP_MESSAGE}
            </Popover.Content>
          </Popover>
        }
      >
        <div className="d-inline-block">
          <img src={displayIcon} alt="extended" className="ml-2" />
        </div>
      </OverlayTrigger>
      {showText && 'Extended Request'}
    </div>
  );
};

export default ExtendedTooltip;
